<template>
  <Transition name="privacy-fade">
    <div v-if="visible" class="privacy-consent-card">
      <div class="privacy-consent-card__header">
        <span class="privacy-consent-card__title">用户协议和隐私政策</span>
        <button class="privacy-consent-card__close" @click="onRefuse">
          <el-icon><Close /></el-icon>
        </button>
      </div>
      <div class="privacy-consent-card__body">
        <p class="privacy-consent-card__desc">
          使用本服务前，请你务必仔细阅读并充分理解<a
            href="https://www.yangtuoedu.com/privacy-policy/user-agreements/userAgreement-pte.html"
            target="_blank"
            rel="noopener noreferrer"
            >《用户协议》</a
          >和<a
            href="https://www.yangtuoedu.com/privacy-policy?appType=25"
            target="_blank"
            rel="noopener noreferrer"
            >《羊驼PTE隐私政策》</a
          >的全部内容。为了向你提供正常及优化的服务，我们可能会收集你的设备标识、操作日志等必要信息，用于保障服务安全、改进产品体验。你可以点击查看《用户协议》和《隐私政策》以了解详细内容。若你已充分阅读并同意上述协议和政策，请点击下方按钮开始使用我们的服务。
        </p>
      </div>
      <div class="privacy-consent-card__footer">
        <el-button type="primary" plain @click="onRefuse">暂不同意</el-button>
        <el-button type="primary" plain @click="onAgree">同意并继续</el-button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { Close } from '@element-plus/icons-vue'
import { router } from '@/router'
import {
  consentRefuseSignal,
  grantPrivacyConsent,
  refusePrivacyConsent,
  shouldShowConsentDialog
} from '@/utils/privacy-consent'
import { ytWebTracking } from '@/utils/web-Tracking'

const visible = ref(false)

onMounted(() => {
  // 未同意且不在拒绝冷却期（72小时）内时弹出指引
  if (shouldShowConsentDialog()) {
    visible.value = true
  }
})

const onAgree = () => {
  grantPrivacyConsent()
  visible.value = false
  // 补报当前落地页的 page_view（同意前的访问不予补报）
  const route = router.currentRoute.value
  ytWebTracking.pushPageEnter({
    is_entry: false,
    router_path: route.path,
    page_name: route.name as string,
    eventType: 'page_view',
    referrer: document.referrer
  })
}

const onRefuse = () => {
  refusePrivacyConsent() // 记录拒绝时间，72小时内不再弹窗
  consentRefuseSignal.value++ // 通知个人中心等页面：登录态下需走撤回授权流程
  visible.value = false
}
</script>

<style lang="scss" scoped>
.privacy-consent-card {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 2000;
  width: 420px;
  padding: 20px;
  border-radius: 12px;
  background-color: var(--el-bg-color);
  box-shadow: var(--el-box-shadow-light);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  &__title {
    color: var(--el-text-color-primary);
    font-size: var(--el-font-size-large);
    font-weight: 600;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background-color: transparent;
    color: var(--el-text-color-secondary);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--el-fill-color);
      color: var(--el-text-color-primary);
    }
  }

  &__body {
    margin-bottom: 16px;
  }

  &__desc {
    margin: 0;
    color: var(--el-text-color-regular);
    font-size: var(--el-font-size-base);
    line-height: 1.7;

    a {
      color: var(--el-color-primary);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}

.privacy-fade-enter-active,
.privacy-fade-leave-active {
  transition: all 0.3s ease;
}

.privacy-fade-enter-from,
.privacy-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
